import {
  RuntimeRepository,
  CompanyRepository,
  UserRepository
} from "core/repository";
import { Base2Presenter } from "core/presenter";

class TopbarPresenter extends Base2Presenter {
  initialState() {
    return {
      currentUser: {
        id: "",
        name: ""
      },
      userInfo: {
        displayCompanyChangeModal: false
      },
      displayCompanyChangeModal: false,
      multilocalityOpen: false,
      companySearchOptions: {
        online: true,
        repository: CompanyRepository,
        order: [{ field: "slug", direction: "ASC" }],
        pagination: { page: 1, perPage: 25 },
        filter: async filter => await this.getFilter(filter)
      }
    };
  }

  async doMenuClick() {
    const sidebarOpen = await this.mRuntime.get(
      RuntimeRepository.props.sidebarOpen
    );
    this.mRuntime.set(RuntimeRepository.props.sidebarOpen, !sidebarOpen);
  }

  async onStart() {
    this.doLoadUserInfo();
    this.doLoadCompanies();
    this.resetSupportVisible();
  }

  resetSupportVisible() {
    this.mRuntime.set(RuntimeRepository.props.supportVisible, false);
  }

  async onToggleHelp() {
    const supportVisible = await this.mRuntime.get(
      RuntimeRepository.props.supportVisible
    );

    this.mRuntime.set(RuntimeRepository.props.supportVisible, !supportVisible);
  }

  async onChangeProps() {
    this.renewCancelToken();

    const result = await UserRepository.getOnline(
      this.viewModel.currentUser.uuid
    );

    if (result.success) {
      this.enqueue(vm => ({
        userInfo: { ...vm.userInfo, name: result.data.name }
      }));
    }
  }

  async doLoadUserInfo() {
    const currentUser = await this.mRuntime.get(
      RuntimeRepository.props.currentUser
    );

    this.enqueue({
      currentUser: currentUser || { id: "", name: "" },
      userInfo: currentUser
    });
  }

  async doLoadCompanies() {
    const result = await CompanyRepository.getListOnline({
      pagination: { perPage: 1 }
    });
    const foundCompanies = result.success && result.headers.total > 1;
    const hasPermissions = this.viewModel.currentUser.permissions.find(
      permission => permission === "manage_companies"
    );

    this.enqueue({
      displayCompanyChangeModal: foundCompanies && hasPermissions
    });
  }

  doCompanyChange() {
    this.enqueue({ multilocalityOpen: true });
  }

  onMultilocalityClose() {
    this.enqueue({ multilocalityOpen: false });
  }

  async onSelectCompany(company) {
    const response = await UserRepository.update(
      this.viewModel.currentUser.uuid,
      {
        company_uuid: company.uuid,
        username: this.viewModel.currentUser.username
      }
    );

    if (response.success) {
      await this.sendNotification({
        type: "success",
        content: "Empresa trocada com sucesso!"
      });
      this.navigateTo("app.login");
    } else {
      await this.sendNotification({
        type: "error",
        title: "Não foi possível trocar a empresa...",
        content: response.error
      });
    }
  }

  doEditInfo() {
    const userUuid = this.viewModel.currentUser.uuid;
    this.navigateTo("app.registration.user.form", { userUuid });
  }

  async getFilter(filter) {
    return [
      { connector: "AND", field: "slug", operation: "LIKE", value: filter },
      {
        connector: "OR",
        field: "fiscal_informations.cnpj",
        operation: "LIKE",
        value: filter
      },
      {
        connector: "OR",
        field: "fiscal_informations.legal_name",
        operation: "LIKE",
        value: filter
      }
    ];
  }

  async doLogout() {
    await UserRepository.signOut();
    this.navigateTo("app.login");
  }
}

export default TopbarPresenter;



// WEBPACK FOOTER //
// ./src/components/support/topbar/presenter.js